import gql from 'graphql-tag';

const GET_ORG_CRM_INTEGRATIONS = gql`
  query OrgCRMIntegrations($where: OrgWhereUniqueInput!) {
    org(where: $where) {
      id
      salesforceId
      externalCRMCampaignIntegrations {
        id
        metadata
      }
    }
  }
`;

export default GET_ORG_CRM_INTEGRATIONS;
